<template>
    <div class="voice-configuration">
        <div class="header">
            <div class="header-content">
                <h2 class="title">Ses Ayarları</h2>
                <p class="subtitle">WhatsApp Business sesli arama ayarlarını yapılandırın</p>
            </div>
        </div>

        <div class="form-container">
            <div class="form-layout">
                <div class="switches-section">
                    <h3 class="section-title">Genel Ayarlar</h3>

                    <div class="switch-group">
                        <label class="switch-label">
                            <span class="label-text">Ses Aktif</span>
                            <span class="label-description">Sesli arama özelliğini etkinleştirin</span>
                        </label>
                        <a-switch v-model="payload.enable" size="small" />
                    </div>

                    <div class="switch-group">
                        <label class="switch-label">
                            <span class="label-text">Kayıt</span>
                            <span class="label-description">SIP kaydını etkinleştirin</span>
                        </label>
                        <a-switch v-model="payload.metaData.is_register" size="small" />
                    </div>

                    <div class="switch-group">
                        <label class="switch-label">
                            <span class="label-text">Force TCP</span>
                            <span class="label-description">TCP protokolünü zorla kullan</span>
                        </label>
                        <a-switch v-model="payload.metaData.force_tcp" size="small" />
                    </div>
                </div>

                <div class="inputs-section">
                    <div class="inputs-layout">
                        <div class="input-section">
                            <h3 class="section-title">SIP Sunucu Ayarları</h3>

                            <div class="input-group">
                                <label class="input-label">
                                    <span class="label-text">Host <span class="required">*</span></span>
                                    <span class="label-description">SIP sunucu adresi</span>
                                </label>
                                <a-input v-model="payload.metaData.host" placeholder="örn: sip.example.com"
                                    size="default" />
                            </div>

                            <div class="input-group">
                                <label class="input-label">
                                    <span class="label-text">Port</span>
                                    <span class="label-description">SIP sunucu portu</span>
                                </label>
                                <a-input v-model="payload.metaData.port" placeholder="5060" size="default"
                                    type="number" />
                            </div>
                        </div>

                        <div class="input-section">
                            <h3 class="section-title">Kimlik Doğrulama</h3>

                            <div class="input-group">
                                <label class="input-label">
                                    <span class="label-text">Kullanıcı</span>
                                    <span class="label-description">SIP kullanıcı kimliği</span>
                                </label>
                                <a-input v-model="payload.metaData.user" placeholder="Kullanıcı ID'si girin"
                                    size="default" />
                            </div>

                            <div class="input-group">
                                <label class="input-label">
                                    <span class="label-text">Kullanıcı Adı</span>
                                    <span class="label-description">SIP kullanıcı adı</span>
                                </label>
                                <a-input v-model="payload.metaData.username" placeholder="Kullanıcı adını girin"
                                    size="default" />
                            </div>
                            <div class="input-group">
                                <label class="input-label">
                                    <span class="label-text">Secret Key</span>
                                    <span class="label-description">SIP Secret Key</span>
                                </label>
                                <a-input v-model="payload.metaData.secret_key" placeholder="Secret Key girin"
                                         size="default" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="form-footer">
            <div class="footer-actions">
                <a-button size="large" @click="handleCancel" class="cancel-btn">
                    <a-icon type="close" />
                    İptal
                </a-button>
                <a-button size="large" type="primary" @click="handleSave" :loading="loading" class="save-btn">
                    <a-icon type="save" />
                    Kaydet
                </a-button>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import _ from "lodash";
import log2 from "../../../../utils/log2";
import WHATSAPP_API from "../../../../api/whatsapp";

const log = log2("VoiceConfiguration.vue");
export default Vue.extend({
    name: "VoiceConfiguration",
    props: {
        value: {
            required: true,
        },
    },
    data() {
        const clone = _.cloneDeep(this.value);

        const voiceConfig = _.get(clone, 'payload.voiceConfiguration') || {
            enable: false,
            metaData: {
                is_register: false,
                user: "",
                username: "",
                host: "",
                port: "5060",
                force_tcp: false,
                secret_key: "",
            }
        };

        if (!voiceConfig.metaData) {
            voiceConfig.metaData = {
                is_register: false,
                user: "",
                username: "",
                host: "",
                port: "5060",
                force_tcp: false,
                secret_key: "",
            };
        }

        return {
            clone,
            loading: false,
            payload: _.cloneDeep(voiceConfig),
        };
    },
    methods: {

        handleCancel() {
            this.$emit("cancel");
        },
        async handleSave() {
            this.loading = true;
            await WHATSAPP_API.BUSINESS.updateVoiceConfiguration(this.clone._id, this.payload.enable, this.payload.metaData).then(() => {
                if (!this.clone.payload) {
                    this.clone.payload = {};
                }
                this.clone.payload.voiceConfiguration = this.payload;
                this.$emit("save", this.clone);
            }).catch((err) => {
                this.$message.error("Sesli arama ayarları güncellenemedi");
            })
            this.loading = false;
        },
    },
    watch: {
        clone: {
            handler: function (val) {
                if (val) {
                    const isChanged = !_.isEqual(val, this.value);
                    if (isChanged) {
                        log("clone changed=>", val);
                        this.$emit("input", val);
                    }
                }
            },
            deep: true,
        },
        value: {
            handler: function (val) {
                const isChanged = !_.isEqual(val, this.clone);
                if (isChanged) {
                    log("value changed=>", val);
                    this.clone = _.cloneDeep(val);

                    const voiceConfig = _.get(this.clone, 'payload.voiceConfiguration') || {
                        enable: false,
                        metaData: {
                            is_register: false,
                            user: "",
                            username: "",
                            host: "",
                            port: "5060",
                            force_tcp: false,
                        }
                    };

                    if (!voiceConfig.metaData) {
                        voiceConfig.metaData = {
                            is_register: false,
                            user: "",
                            username: "",
                            host: "",
                            port: "5060",
                            force_tcp: false,
                        };
                    }

                    this.payload = _.cloneDeep(voiceConfig);
                }
            },
            deep: true,
        },
    },
});
</script>

<style scoped lang="scss">
.voice-configuration {
    max-width: 800px;
    margin: 0 auto;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    overflow: hidden;
    margin-top: 30px;

    .header {
        background: #f8f9fa;
        border-bottom: 1px solid #e9ecef;
        padding: 16px 24px;

        .header-content {
            .title {
                font-size: 20px;
                font-weight: 600;
                margin: 0 0 4px 0;
                color: #2c3e50;
            }

            .subtitle {
                font-size: 13px;
                margin: 0;
                color: #6c757d;
            }
        }
    }

    .form-container {
        padding: 20px 32px;

        .form-layout {
            display: grid;
            grid-template-columns: 1fr 2fr;
            gap: 40px;
            align-items: start;
        }

        .section-title {
            font-size: 16px;
            font-weight: 600;
            color: #2c3e50;
            margin: 0 0 12px 0;
            padding-bottom: 6px;
            border-bottom: 2px solid #f0f2f5;
            position: relative;

            &::after {
                content: '';
                position: absolute;
                bottom: -2px;
                left: 0;
                width: 40px;
                height: 2px;
                background: #6c757d;
            }
        }

        .switches-section {
            .switch-group {
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 12px 0;
                border-bottom: 1px solid #f0f2f5;

                &:last-child {
                    border-bottom: none;
                }

                .switch-label {
                    display: flex;
                    flex-direction: column;
                    gap: 4px;
                    flex: 1;

                    .label-text {
                        font-size: 14px;
                        font-weight: 500;
                        color: #2c3e50;
                    }

                    .label-description {
                        font-size: 12px;
                        color: #7f8c8d;
                        font-weight: 400;
                    }
                }
            }
        }

        .inputs-section {
            .inputs-layout {
                display: grid;
                grid-template-columns: 1fr 1fr;
                gap: 30px;
            }

            .input-section {
                .input-group {
                    display: flex;
                    flex-direction: column;
                    gap: 6px;
                    margin-bottom: 14px;

                    &:last-child {
                        margin-bottom: 0;
                    }

                    .input-label {
                        display: flex;
                        flex-direction: column;
                        gap: 4px;

                        .label-text {
                            font-size: 14px;
                            font-weight: 500;
                            color: #2c3e50;

                            .required {
                                color: #e74c3c;
                                margin-left: 2px;
                            }
                        }

                        .label-description {
                            font-size: 12px;
                            color: #7f8c8d;
                            font-weight: 400;
                        }
                    }

                    :deep(.ant-input),
                    :deep(.ant-input-password) {
                        border-radius: 6px;
                        border: 1px solid #d9d9d9;
                        transition: all 0.2s ease;

                        &:hover {
                            border-color: #adb5bd;
                        }

                        &:focus {
                            border-color: #6c757d;
                            box-shadow: 0 0 0 2px rgba(108, 117, 125, 0.2);
                        }
                    }
                }
            }
        }
    }

    .form-footer {
        background: #f8f9fa;
        padding: 14px 32px;
        border-top: 1px solid #e9ecef;

        .footer-actions {
            display: flex;
            justify-content: flex-end;
            gap: 12px;

            .cancel-btn {
                border-radius: 6px;
                height: 36px;
                padding: 0 16px;
                border: 1px solid #d9d9d9;

                &:hover {
                    border-color: #6c757d;
                    color: #6c757d;
                }
            }

            .save-btn {
                border-radius: 6px;
                height: 36px;
                padding: 0 16px;
                background: #6c757d;
                border: none;
                font-weight: 500;

                &:hover {
                    background: #5a6268;
                    transform: translateY(-1px);
                    box-shadow: 0 4px 12px rgba(108, 117, 125, 0.3);
                }

                &:focus {
                    background: #6c757d;
                    box-shadow: 0 0 0 2px rgba(108, 117, 125, 0.2);
                }
            }
        }
    }
}

// Responsive design
@media (max-width: 768px) {
    .voice-configuration {
        margin: 0;
        border-radius: 0;

        .form-container {
            padding: 20px;

            .form-layout {
                grid-template-columns: 1fr;
                gap: 24px;
            }

            .inputs-section .inputs-layout {
                grid-template-columns: 1fr;
                gap: 20px;
            }
        }

        .form-footer {
            padding: 16px 20px;

            .footer-actions {
                flex-direction: column-reverse;
                gap: 8px;

                .cancel-btn,
                .save-btn {
                    width: 100%;
                }
            }
        }
    }
}
</style>
